<template>
  <div class="index">
    <Banner></Banner>
    <Choose v-on:choose="scroll"></Choose>
    <Toothbrushes :selected="selected" :redirect="true"></Toothbrushes>
  </div>
</template>

<script>
import Banner from './Banner.vue'
import Choose from './Choose.vue'
import Toothbrushes from './Toothbrushes.vue'
import VueScrollTo from 'vue-scrollto'

export default {
  data () {
    return {
      selected: false
    }
  },
  components: {
    Banner,
    Choose,
    Toothbrushes
  },
  watch: {
    '$route' (to, from) {
      this.selected = to.params.paste
      if (this.selected) {
        VueScrollTo.scrollTo('.toothbrushes-wrapper')
      }
    }
  },
  created: function () {
    this.selected = this.$route.params.paste
  },
  methods: {
    scroll: function () {
      VueScrollTo.scrollTo('.toothbrushes')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/index/Index.vue